import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useParams} from "react-router-dom";
import IconEmail from "../img/icons/icon-round-email.svg";
import IconFacebook from "../img/icons/icon-round-facebook.svg";
import IconTwitter from "../img/icons/icon-round-twitter.svg";
import IconLine from "../img/icons/icon-round-line.svg";
import IconDocument from "../img/icons/icon-file-download.svg";
import IconUser from "../img/icons/icon-user-outline.svg";
import IconDownload from "../img/icons/icon-download-outline.svg";

export default function ResearchDetail(prop) {
    let {slug} = useParams();

    let [data, setData] = React.useState(null);
    let [detail, setDetail] = React.useState(null);
    let [downloadCount, setDownloadCount] = React.useState(0);

    let [positionListing, setPositionListing] = React.useState(null);
    let [educationListing, setEducationListing] = React.useState(null);
    let [workListing, setWorkListing] = React.useState(null);
    let [expertiseListing, setExpertiseListing] = React.useState(null);
    let [coauthorListing, setCoauthorListing] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getView();
                setData(resView);

                const resDetail = await getDetail();
                if(resDetail) {
                    if(prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                        resDetail.abstract = resDetail.abstract_en;
                        resDetail.keywords = resDetail.keywords_en;
                        resDetail.researchType.title = resDetail.researchType.title_en;
                        resDetail.researchFormat.title = resDetail?.researchFormat?.title_en;
                        resDetail.researchDoctype.title = resDetail?.researchDoctype?.title_en;
                        resDetail.researchAgency.title = resDetail?.researchAgency?.title_en;
                        resDetail.capitlaType.title = resDetail?.capitlaType?.title_en;
                        resDetail.capitlaSource.title = resDetail?.capitlaSource?.title_en;
                        resDetail.fiscalYear.title = resDetail?.fiscalYear?.title_en;

                        resDetail.contact = resDetail.contact_en;
                        resDetail.prefix = resDetail.prefix_en;
                        resDetail.firstname = resDetail.firstname_en;
                        resDetail.lastname = resDetail.lastname_en;
                    }
                    setDownloadCount(resDetail.download);
                    setDetail(resDetail);
                    document.title = 'ข้อมูลงานวิจัย | NCSA - ' + resDetail?.title;

                    let positionResult = await getPosition(resDetail.id);
                    setPositionListing(positionResult);
                    let educationResult = await getEducationListing(resDetail.id);
                    setEducationListing(educationResult);
                    let workResult = await getWorkListing(resDetail.id);
                    setWorkListing(workResult);
                    let expertiseResult = await getExpertiseListing(resDetail.id);
                    setExpertiseListing(expertiseResult);
                    let coauthorResult = await getCoauthorListing(resDetail.id);
                    setCoauthorListing(coauthorResult);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/researchBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/research/viewSlug', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                slug: slug
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onDownload = async () => {
        const update = await updateDownload();
        if(update) {
            setDownloadCount(update.download);
        }
    };

    async function updateDownload() {
        const response = await fetch(Config.apiUrl +'/research/updateDownload', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: detail.id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getPosition(id) {
        const response = await fetch(Config.apiUrl +'/researchPosition/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researchId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getEducationListing(id) {
        const response = await fetch(Config.apiUrl +'/researchEducation/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researchId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getWorkListing(id) {
        const response = await fetch(Config.apiUrl +'/researchWork/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researchId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getExpertiseListing(id) {
        const response = await fetch(Config.apiUrl +'/researchExpertise/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researchId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getCoauthorListing(id) {
        const response = await fetch(Config.apiUrl +'/researchCoauthor/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researchId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'research_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Research':'ข้อมูลงานวิจัย'}</span>
                    </h1>
                    <p data-aos="fade-in">
                        <NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / <NavLink to='#'>{prop.lang === 'en' ? 'NCSA Database':'ฐานข้อมูลของ สกมช.'}</NavLink> / <NavLink to={ (prop.lang === 'en' ? '/en':'') + "/research"}>{prop.lang === 'en' ? 'Research':'ข้อมูลงานวิจัย'}</NavLink>
                    </p>
                </div>
            </div>

            <div className="section">
                <div className="container has-sidebar" data-aos="fade-in">
                    <div className="content">
                        <div className="card-infos" data-aos="fade-in">
                            <h3 className="fs-20">{detail?.title}</h3>
                            <p className="date">{prop.lang === 'en' ? 'Published on':'วันที่เผยแพร่'} {Utils.dateDMY(detail?.createdAt, prop.lang)}</p>

                            <hr className="mb-4" />

                            <div className="row g-2">
                                <div className="col-12">
                                    <ul className="infos-list m-0">
                                        <li>
                                            <h6>{prop.lang === 'en' ? 'Author':'ผู้แต่ง'} :</h6>
                                            <p>{detail?.prefix + ' ' + detail?.firstname + ' ' + detail?.lastname}</p>
                                        </li>

                                        {
                                            detail?.researchCoauthor !== null && detail?.researchCoauthor.length > 0 ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Author':'ผู้แต่งร่วม'} :</h6>
                                                    <p>
                                                        {prop.lang === 'en' ? detail?.researchCoauthor.map(function (rs) {
                                                            return rs.prefix_en + ' '  +rs.firstname_en + ' '  +rs.lastname_en;
                                                        }).join(', ') : detail?.researchCoauthor.map(function (rs) {
                                                            return rs.prefix + ' '  +rs.firstname + ' '  +rs.lastname;
                                                        }).join(', ')
                                                        }
                                                    </p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.researchAgency ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Agency':'หน่วยงาน'} :</h6>
                                                    <p>{prop.lang === 'en' ? detail?.researchAgency.title_en:detail?.researchAgency.title}</p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.researchType ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Research Type':'ประเภทงานวิจัย'} :</h6>
                                                    <p>{prop.lang === 'en' ? detail?.researchType.title_en:detail?.researchType.title}</p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.researchFormat ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Research Format':'รูปแบบงานวิจัย'} :</h6>
                                                    <p>{prop.lang === 'en' ? detail?.researchFormat.title_en:detail?.researchFormat.title}</p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.researchDoctype ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Research Document':'ประเภทเอกสาร'} :</h6>
                                                    <p>{prop.lang === 'en' ? detail?.researchDoctype.title_en:detail?.researchDoctype.title}</p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.capitalType ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Capital Type':'ประเภททุน'} :</h6>
                                                    <p>{prop.lang === 'en' ? detail?.capitalType.title_en:detail?.capitalType.title}</p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.capitalSource ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Capital Source':'แหล่งทุน'} :</h6>
                                                    <p>{prop.lang === 'en' ? detail?.capitalSource.title_en:detail?.capitalSource.title}</p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.fiscalYear ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Fiscal Year':'ปีงบประมาณ'} :</h6>
                                                    <p>{prop.lang === 'en' ? detail?.fiscalYear.title_en:detail?.fiscalYear.title}</p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.keywords ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Keywords':'คำสำคัญ'} :</h6>
                                                    <p>{prop.lang === 'en' ? detail?.keywords_en:detail?.keywords}</p>
                                                </li> : ''
                                        }
                                    </ul>
                                </div>

                                <div className="col-12">
                                    <hr className="my-md-3 my-2" />
                                </div>

                                {
                                    detail?.abstract ?
                                        <div className="col-12">
                                            <ul className="infos-list m-0">
                                                <li>
                                                    <h6>บทคัดย่อ :</h6>
                                                    <p dangerouslySetInnerHTML={{__html: detail?.abstract.replace(/\n/g, "<br />")}}></p>
                                                </li>
                                            </ul>
                                        </div> : ''
                                }
                            </div>
                        </div>

                        <div className="col-12 pt-sm-5 pt-4">
                            {
                                detail?.contact ?
                                    <div className="card-accordion">
                                        <div className="card-header" data-bs-toggle="collapse"
                                             data-bs-target="#collapse2" aria-expanded="false">
                                            <h2>{prop.lang === 'en' ? 'Researcher contact information':'ข้อมูลติดต่อนักวิจัย'}</h2>
                                            <span className="arrow"></span>
                                        </div>

                                        <div id="collapse2" className="accordion-collapse collapse">
                                            <div className="card-body" dangerouslySetInnerHTML={{__html: detail?.contact.replace(/\n/g, "<br />")}}>
                                            </div>
                                        </div>
                                    </div> : ''
                            }

                            {
                                educationListing !== null && educationListing.rows.length > 0 ?
                                    <div className="card-accordion">
                                        <div className="card-header" data-bs-toggle="collapse"
                                             data-bs-target="#collapseEducation" aria-expanded="false">
                                            <h2>{prop.lang === 'en' ? 'Educational record':'ประวัติการศึกษา'}</h2>
                                            <span className="arrow"></span>
                                        </div>

                                        <div id="collapseEducation" className="accordion-collapse collapse">
                                            <div className="card-body">
                                                {
                                                    educationListing.rows.map((row, index) => {
                                                        return (
                                                            <div key={index} className="mb-3">
                                                                <h3>{prop.lang === 'en' ? row.institution_en:row.institution}</h3>
                                                                <p className="mb-0">{prop.lang === 'en' ? 'Course/Major : ' + row.program_en:'หลักสูตร/สาขา : ' + row.program}</p>
                                                                <p className="mb-0">{prop.lang === 'en' ? 'Degree : ' + row.level_en:'ระดับการศึกษา : ' + row.level}</p>
                                                                <p className="mb-0">{prop.lang === 'en' ? 'Year of graduation : ' + row.year_en:'ปีที่จบการศึกษา : ' + row.year}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div> : ''
                            }

                            {
                                workListing !== null && workListing.rows.length > 0 ?
                                    <div className="card-accordion">
                                        <div className="card-header" data-bs-toggle="collapse"
                                             data-bs-target="#collapseWork" aria-expanded="false">
                                            <h2>{prop.lang === 'en' ? 'Work history':'ประวัติการทำงาน'}</h2>
                                            <span className="arrow"></span>
                                        </div>

                                        <div id="collapseWork" className="accordion-collapse collapse">
                                            <div className="card-body">
                                                {
                                                    workListing.rows.map((row, index) => {
                                                        return (
                                                            <div key={index} className="mb-3">
                                                                <h3>{prop.lang === 'en' ? row.company_en:row.company}</h3>
                                                                <p className="mb-0">{prop.lang === 'en' ? 'Position : ' + row.position_en:'ตำแหน่ง : ' + row.position}</p>
                                                                {
                                                                    row.startDate ?
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Start Date : ' + Utils.dateTimeDMY(row.startDate):'วันที่เริ่มทำงาน : ' + Utils.dateTimeDMY(row.startDate)}</p> : ''
                                                                }
                                                                {
                                                                    row.endDate ?
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'End Date : ' + Utils.dateTimeDMY(row.endDate):'วันสิ้นสุดการทำงาน : ' + Utils.dateTimeDMY(row.endDate)}</p> : ''
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div> : ''
                            }

                            {
                                expertiseListing !== null && expertiseListing.rows.length > 0 ?
                                    <div className="card-accordion">
                                        <div className="card-header" data-bs-toggle="collapse"
                                             data-bs-target="#collapseExpertises" aria-expanded="false">
                                            <h2>{prop.lang === 'en' ? 'Expertises':'ข้อมูลความเชี่ยวชาญ'}</h2>
                                            <span className="arrow"></span>
                                        </div>

                                        <div id="collapseExpertises" className="accordion-collapse collapse">
                                            <div className="card-body">
                                                {
                                                    expertiseListing.rows.map((row, index) => {
                                                        return (
                                                            <div key={index} className="mb-3">
                                                                <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div> : ''
                            }

                            {
                                coauthorListing !== null && coauthorListing.rows.length > 0 ?
                                    <div className="card-accordion">
                                        <div className="card-header" data-bs-toggle="collapse"
                                             data-bs-target="#collapseCoAuthor" aria-expanded="false">
                                            <h2>{prop.lang === 'en' ? 'Co-Author':'ผู้แต่งร่วม'}</h2>
                                            <span className="arrow"></span>
                                        </div>

                                        <div id="collapseCoAuthor" className="accordion-collapse collapse">
                                            <div className="card-body">
                                                {
                                                    coauthorListing.rows.map((row, index) => {
                                                        return (
                                                            <div key={index} className="mb-3">
                                                                <h3>{prop.lang === 'en' ? row.prefix_en + ' ' + row.firstname_en + ' ' + row.lastname_en:row.prefix + ' ' + row.firstname + ' ' + row.lastname}</h3>
                                                                <p className="mb-0">{prop.lang === 'en' ? 'Position : ' + row.position_en:'ตำแหน่งงาน : ' + row.position}</p>
                                                                <p className="mb-0">{prop.lang === 'en' ? 'Agency/Institution : ' + row.agency_en:'หน่วยงาน : ' + row.agency}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div> : ''
                            }
                        </div>

                    </div>

                    <div className="sidebar">
                        <div className="card-statistic" data-aos="fade-in">
                            <div className="row">
                                <div className="col-6">
                                    <div className="card-header">
                                        <span className="card-icon">
                                            <img className="icons svg-js" src={IconUser} alt="" />
                                        </span>
                                        <h4>{prop.lang === 'en' ? 'เข้าชม':'Views'}</h4>
                                    </div>
                                    <h2 className="card-title">{detail?.view ? Utils.numberWithCommas(detail.view) : 0}</h2>
                                </div>

                                <div className="col-6 border-left">
                                    <div className="card-header">
                                        <span className="card-icon">
                                            <img className="icons svg-js" src={IconDownload} alt="" />
                                        </span>
                                        <h4>{prop.lang === 'en' ? 'ดาวน์โหลดแล้ว':'Downloaded'}</h4>
                                    </div>
                                    <h2 className="card-title">{detail?.download ? Utils.numberWithCommas(downloadCount) : 0}</h2>
                                </div>
                            </div>
                        </div>

                        {
                            detail?.researchFile && detail?.researchFile.length > 0 ?
                                <>
                                    <h3 className="title-line-left textrow">
                                        <span data-aos="fade-right">{prop.lang === 'en' ? 'Documents':'เอกสารเผยแพร่'}</span>
                                    </h3>
                                    <div className="row g-sm-3 g-2">
                                        {
                                            detail.researchFile.map((rs, index) => {
                                                return (
                                                    <div key={index} className="col-lg-12 col-sm-6" data-aos="fade-in" onClick={onDownload}>
                                                        <NavLink className="btn btn-xl btn-download" download to={Config.fileUpload + 'research_file/' + rs.file} target="_blank">
                                                            <img className="icons" src={IconDocument} alt="" />
                                                            <div>
                                                                <p className="fs-20">{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</p>
                                                                <p className="fs-14">{prop.lang === 'en' ? rs.title_en:rs.title}</p>
                                                            </div>
                                                        </NavLink>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </> : ''
                        }

                        <h3 className="title-line-left textrow">
                            <span data-aos="fade-right">{prop.lang === 'en' ? 'Share on Social media':'แชร์ข้อมูลไปยังโซเชียลมีเดีย'}</span>
                        </h3>
                        <div className="share-icons mb-4" data-aos="fade-in">
                            <NavLink to={"https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href)} target="_blank">
                                <img className="icons" src={IconFacebook} alt="" />
                            </NavLink>
                            <NavLink to={"https://twitter.com/intent/tweet?text=" + encodeURIComponent(document.title) + ' ' + encodeURIComponent(window.location.href)} target="_blank">
                                <img className="icons" src={IconTwitter} alt="" />
                            </NavLink>
                            <NavLink to={"https://social-plugins.line.me/lineit/share?url=" + encodeURIComponent(window.location.href)} target="_blank">
                                <img className="icons" src={IconLine} alt="" />
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 